module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/symptoms-b7462151430e694e26918feb9d629e82.svg";